// extracted by mini-css-extract-plugin
export default {"container":"UndoMessage_container__RfGPM","closeContainer":"UndoMessage_closeContainer__01tKU"};